import axios from "axios";
import toast from "react-hot-toast";

export async function buscarNumeroNegocioBaserow(numeroNegocio) {
    try {
        // Buscar todos los registros con el mismo número de negocio
        let filterGastos = encodeURIComponent(`{"filter_type":"AND","filters":[{"type":"equal","field":"Numero Negocio","value":"${numeroNegocio}"}],"groups":[]}`);
        const orderBy = encodeURIComponent('-Fecha Creación del Registro');
        const urlGastos = `https://db.coventia.es/api/database/rows/table/870/?user_field_names=true&filters=${filterGastos}&order_by=${orderBy}`;

        const responseGastos = await axios({
            method: "GET",
            url: urlGastos,
            headers: {
                Authorization: `Token ${import.meta.env.VITE_BASEROW_AUTH_TOKEN}`,
                "Content-Type": "application/json"
            },
        });

        if (responseGastos.data.results.length > 0) {
            // Recopilar todos los DNIs del array DNI Foreign
            const dniArray = responseGastos.data.results[0]["DNI Foreign"] || [];
            
            if (dniArray.length === 0) {
                console.error('No se encontraron DNIs en los registros de gastos');
                return false;
            }

            // Buscar datos personales para todos los DNIs encontrados
            const datosPersonales = [];
            for (const dniObj of dniArray) {
                let filterDatosPersonales = encodeURIComponent(`{"filter_type":"AND","filters":[{"type":"equal","field":"DNI","value":"${dniObj.value}"}],"groups":[]}`);
                const urlDatosPersonales = `https://db.coventia.es/api/database/rows/table/871/?user_field_names=true&filters=${filterDatosPersonales}`;

                const responseDatosPersonales = await axios({
                    method: "GET",
                    url: urlDatosPersonales,
                    headers: {
                        Authorization: `Token ${import.meta.env.VITE_BASEROW_AUTH_TOKEN}`,
                        "Content-Type": "application/json"
                    },
                });

                if (responseDatosPersonales.data.results.length > 0) {
                    datosPersonales.push(responseDatosPersonales.data.results[0]);
                }
            }

            if (datosPersonales.length > 0) {
                const confirmar = window.confirm(`Se encontraron ${datosPersonales.length} persona(s) asociadas al número de negocio. ¿Quieres rellenar el formulario con los datos almacenados?`);
                if (confirmar) {
                    // Limpiar datos nulos o undefined de gastos
                    const gastosLimpios = responseGastos.data.results.map(gasto => {
                        const gastoLimpio = {};
                        for (const key in gasto) {
                            if (gasto[key] !== null && gasto[key] !== undefined) {
                                gastoLimpio[key] = gasto[key];
                            }
                        }
                        return gastoLimpio;
                    });

                    return [datosPersonales[0], gastosLimpios, datosPersonales[1] || null];
                }
            }
        }
        else {
            toast.error('No se encontraron datos personales asociados al número de negocio');
        }
        return false;
    } catch (error) {
        console.error('Error al buscar el número de negocio en Baserow:', error);
        return false;
    }
}